import {
  listRequest,
  createUpdateRequest,
  priceListRequest,
  updateAllStorePriceRequest,
  storeListRequest,
  updateAllStoreSinglePriceRequest,
  storePriceListRequest,
  updateSingleStorePriceRequest,
  imageListRequest,
  updateTags,
  tagListRequest,
  updateTag,
} from "../../service/ProductService";

/**
 *
 * @param {*} data  JSON DATA TO SEND TO SERVER
 * @returns API RESULT
 */
export const listAction = (data) => async (dispatch) => {
  const response = await dispatch(listRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const storeListAction = (data) => async (dispatch) => {
  const response = await dispatch(storeListRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const priceListAction = (data) => async (dispatch) => {
  const response = await dispatch(priceListRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const storePriceListAction = (data) => async (dispatch) => {
  const response = await dispatch(storePriceListRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const createUpdateAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(createUpdateRequest(requestBody));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const updateAllStorePriceAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(updateAllStorePriceRequest(requestBody));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const updateSingleStorePriceAction =
  (requestBody) => async (dispatch) => {
    const response = await dispatch(updateSingleStorePriceRequest(requestBody));

    if (
      (response &&
        Object.keys(response).length &&
        response?.data?.status == 201) ||
      200
    ) {
      return Promise.resolve(response.data);
    } else {
      return Promise.resolve(null);
    }
  };

export const updateAllStoreSinglePriceAction =
  (requestBody) => async (dispatch) => {
    const response = await dispatch(
      updateAllStoreSinglePriceRequest(requestBody)
    );

    if (
      (response &&
        Object.keys(response).length &&
        response?.data?.status == 201) ||
      200
    ) {
      return Promise.resolve(response.data);
    } else {
      return Promise.resolve(null);
    }
  };

export const imageListAction = (data) => async (dispatch) => {
  const response = await dispatch(imageListRequest(data));
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const tagUpdateAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(updateTags(requestBody));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const tagAssgnAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(updateTag(requestBody));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const taglistAction = (data) => async (dispatch) => {
  const response = await dispatch(tagListRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};
